// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2TqP3","noInteraction":"EventWrapper_noInteraction__OmuBO"};